function inViewport(selectorOrElement, callback, customOptions={}) {
    const element = selectorOrElement instanceof HTMLElement ? selectorOrElement : document.querySelector(selectorOrElement)
    if (!element) return;

	const options = {
		root: null,
		rootMargin: '0px 0px 200px 0px',
		threshold: 0,
		...customOptions
	}

	const innerCallback = (entries, observer) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return
			callback()
			observer.unobserve(entry.target)
		});
	}
	const observer = new IntersectionObserver(innerCallback, options);
	observer.observe(element);
	return observer
}
export default inViewport
